import { Skeleton } from "@/components/ui/skeleton";

// Same blocks as EngagePage: title row with its button, three stat tiles, the status tabs, then campaign rows.
// It stands in for the page while its code loads, so the screen shows one shape from the first frame to the last.
// Keep it in step with the page.
export const CampaignRowsSkeleton = () => (
  <div className="space-y-3">
    {[0, 1, 2].map((i) => <Skeleton key={i} className="h-[74px] rounded-2xl" />)}
  </div>
);

const EngageSkeleton = () => (
  <div className="min-h-screen" aria-busy="true" aria-label="Loading">
    <main className="py-6 pt-10">
      <div className="ernest-container">
        <div className="mb-8 flex items-end justify-between gap-6">
          <div className="min-w-0">
            <Skeleton className="mb-1 h-8 w-44" />
            <Skeleton className="h-6 w-96 max-w-full" />
          </div>
          <Skeleton className="h-10 w-36 shrink-0 rounded-lg" />
        </div>
        <div className="mb-8 grid grid-cols-2 gap-3 sm:grid-cols-3">
          {[0, 1, 2].map((i) => <Skeleton key={i} className="h-[86px] rounded-2xl" />)}
        </div>
        <div className="mb-5 flex items-center gap-1 border-b border-border/70">
          {[56, 84, 72, 92, 88].map((w, i) => (
            <div key={i} className="px-3 py-2.5"><Skeleton className="h-5 rounded" style={{ width: w }} /></div>
          ))}
        </div>
        <CampaignRowsSkeleton />
      </div>
    </main>
  </div>
);

export default EngageSkeleton;
